<template>
  <div class="storageDaPing">
    <!-- 头部 -->
    <div class="heard">
      <div class="img">
        <img src="../../../assets/dapingImg/logo.png" alt />
      </div>
      <span class="title">车辆监控</span>
      <div class="date">
        <span>{{ nowDate + " " + nowWeek }}</span>
      </div>
    </div>
    <div class="con">
      <!-- 地图 -->
      <div
        id="all-map"
        class="map"
        :style="{ width: '99vw', height: '90vh' }"
      ></div>
      <!-- 右侧悬浮 -->
      <div class="right">
        <div class="top_box">
          <div class="tiaoti">作业监控</div>
          <div class="chartsBox">
            <div class="listTitle">
              <div class="item">车牌号</div>
              <div class="item">车辆类型</div>
              <div class="item">状态</div>
            </div>
            <vue-seamless-scroll
              :data="tablesList"
              :class-option="classOption"
              class="seamless-warp"
            >
              <div class="box3">
                <div
                  class="listBox listCont"
                  v-for="(item, index) in tablesList"
                  :key="index"
                >
                  <div class="item">{{ item.vehicleNo }}</div>
                  <div class="item">{{ item.vehicleType }}</div>
                  <div class="item" style="color: #fdfd01" v-if="item.vehicleStatus == '空闲'" >空闲中</div>
                  <div class="item" style="color: #4df442" v-if="item.vehicleStatus == '任务中'" >任务中</div>
                  <div class="item" style="color: #fbae00" v-if="item.vehicleStatus == '待派车'" >待派车</div>
                  <!-- <div class="item" v-else-if="item.vehicleStatus !== '空闲中'">{{ item.vehicleStatus }}</div> -->
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
      <div class="bottom">
        <ul>
          <li>
            <div class="div1"></div>
            &nbsp;&nbsp;&nbsp;&nbsp;空闲中：{{ this.number1 }}
          </li>
          <li>
            <div class="div2"></div>
            &nbsp;&nbsp;&nbsp;&nbsp;待派车：{{ this.number2 }}
          </li>
          <li>
            <div class="div3"></div>
            &nbsp;&nbsp;&nbsp;&nbsp;任务中：{{ this.number3 }}
          </li>
          <li>
            <div class="div4"></div>
            &nbsp;&nbsp;&nbsp;&nbsp;总计数：{{ this.number4 }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import DonMessage from '@/utils/message'
import 'echarts-liquidfill/src/liquidFill.js' // 在这里引入
import AMap from 'AMap'
import { zhbVehicleMonitor } from '@/api/data-center-server'
export default {
  data () {
    return {
      // map: {},
      number1: 0,
      number2: 0,
      number3: 0,
      number4: 0,
      map: '',
      markers: '',
      fugaiList: [], // 后端传过来的划默认工作区域点的坐标
      tablesList: [], // 表格数据
      jinkongData: [1, 2, 3, 4, 5, 6, 7],
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      nowWeek: '' // 当前星期
    }
  },
  computed: {
    classOption () {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: this.jinkongData.length, // 开始无缝滚动的数据量  //this.fourDatata.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  mounted () {
    this.currentTime()
    this.zhbVehicleMonitorS()
    this.GaodeMap()
  },
  methods: {
    // 1- 数据
    zhbVehicleMonitorS () {
      zhbVehicleMonitor({})
        .then((res) => {
          this.number1 = 0
          this.number2 = 0
          this.number3 = 0
          this.number4 = 0
          this.fugaiList = []
          this.tablesList = []
          this.map.clearMap()
          this.map.remove(this.markers)
          // 覆盖数据-点数组
          this.fugaiList = res.multiCoordinate
          // 表格数据
          this.tablesList = res.vehicleMonitorList
          let polygon = new AMap.Polygon({
            path: this.fugaiList,
            strokeColor: '#ee2200',
            strokeWeight: 6,
            strokeOpacity: 0.2,
            fillOpacity: 0.4,
            fillColor: '#F33',
            zIndex: 50
          })
          this.map.add(polygon)
          this.map.setFitView()
          this.tablesList.forEach((item, index) => {
            if (item.vehicleStatus == '空闲') {
              this.number1++
            } else if (item.vehicleStatus == '派车中') {
              this.number2++
            } else if (item.vehicleStatus == '任务中') {
              this.number3++
            }
            let icon = null
            if (item.vehicleStatus == '空闲') {
              icon = new AMap.Icon({
                image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/yuan1.png',
                size: new AMap.Size(68, 68),
                imageSize: new AMap.Size(15, 15)
              })
            } else if (item.vehicleStatus == '派车中') {
              icon = new AMap.Icon({
                image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/yuan3.png',
                size: new AMap.Size(68, 68),
                imageSize: new AMap.Size(15, 15)
              })
            } else {
              icon = new AMap.Icon({
                image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/yuan2.png',
                size: new AMap.Size(68, 68),
                imageSize: new AMap.Size(15, 15)
              })
            }
            if (item.vhcLat !== null && item.vhcLon !== null) {
              // 创建一个 Marker 实例：
              var marker = new AMap.Marker({
                position: new AMap.LngLat(item.vhcLon, item.vhcLat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                icon: icon,
                title: item.vehicleNo
              })
              // 将创建的点标记添加到已有的地图实例：
              this.map.add(marker)
              // this.map.setFitView()
            }
          })

          this.number4 = this.number1 + this.number2 + this.number3

          //  -----------------------------------------------------------------
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 显示地图
    GaodeMap () {
      this.map = new AMap.Map('all-map', {
        center: [116.397428, 39.90923], // [纬度，经度]
        resizeEnable: true,
        zoom: 12,
        mapStyle: 'amap://styles/a2f827603447634b9c005cda4374da49'
      })
      this.map.setFitView()

      // AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function () {
      //   // this.addControl(new AMap.ToolBar())
      //   // this.addControl(new AMap.Scale())
      // })
    },

    // 右侧时间
    currentTime () {
      setInterval(this.getDate, 500)
    },
    getDate: function () {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = '星期一'
      } else if (week == 2) {
        this.nowWeek = '星期二'
      } else if (week == 3) {
        this.nowWeek = '星期三'
      } else if (week == 4) {
        this.nowWeek = '星期四'
      } else if (week == 5) {
        this.nowWeek = '星期五'
      } else if (week == 6) {
        this.nowWeek = '星期六'
      } else {
        this.nowWeek = '星期日'
      }
      _this.nowTime = hh + ':' + mf
      _this.nowDate = yy + '/' + mm + '/' + dd
    }
  }
}
</script>

<style lang='less' scoped>
.storageDaPing {
  width: 100%;
  height: 100vh;
  // display: flex;
  overflow: hidden;
  background: url("../../../assets/dapingImg/bg.png") 100%;
  .heard {
    width: 100%;
    height: 6vh;
    line-height: 6vh;
    display: flex;
    background: url("../../../assets/dapingImg/标题光条.png") no-repeat;
    background-size: 100% 100%;
    text-align: center;
    .title {
      flex: 1;
      font-size: 30px;
      font-weight: 700;
      color: #03faec;
    }
    .date {
      font-size: 16px;
      color: #ffdd17;
    }
    .img {
      height: 6vh;
      // position: absolute;
      z-index: 1111;
      img {
        height: 100%;
      }
    }
  }
  .con {
    width: 100%;
    height: 92vh;
    margin-top: 1vh;
    padding: 20px;
    display: flex;
    box-sizing: border-box;
    position: relative;
    .bottom {
      position: absolute;
      bottom: 0px;
      right: 350px;
      // width: 300px;
      height: 20vh;
      // background-color: rgba(83, 78, 78, 0.514);
      margin-top: 10vh;
      ul {
        display: flex;
        height: 15vh;
        flex-direction: column;
        li {
          flex: 1;
          display: flex;

          box-sizing: border-box;
          padding-top: 10px;
          padding-left: 150px;
          color: #fff;
          div {
            width: 16px;
            height: 16px;
            border-radius: 8px;
          }

        }
         .div1{
            background: #fdfd01;
          }
          .div2{
            background: #fbae00;
          }
          .div3{
            background: #4df442;
          }
          .div4 {
            background: #53535000;
          }
      }
    }
    .right {
      position: absolute;
      right: 20px;
      height: 100%;
      width: 300px;
      background-color: rgba(83, 78, 78, 0.514);
    }
    .listTitle {
      height: 4vh;
      line-height: 4vh;
      background-color: #0c46a2;
      display: flex;
      .item {
        width: 33%;
        text-align: center;
        color: #fff;
      }
    }
    .tiaoti {
      padding-left: 10px;
      height: 4vh;
      line-height: 4vh;
      font-size: 18px;
      font-weight: 700;
      color: #03faec;
      background-color: #3bfff22f;
    }
    .seamless-warp {
      overflow: hidden;
      height: 80vh;
      // line-height: 33vh;
      box-sizing: border-box;
    }
    .listBox {
      display: flex;
      padding: 8px 0;
      font-size: 14px;
      border-bottom: 1px solid #03faec;
      // background-color: rgba(83, 78, 78, 0.514);
    }
    .listBox .item {
      height: 4vh;
      line-height: 4vh;
      color: #03faec;
      width: 33%;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
  }
}
</style>
